<style lang="scss" scoped>


</style>

<template>
    <ImaskInput v-bind="imaskOptions"  type="text" v-model="valueInput"  v-on:blur="focusOut" :placeholder="placeholder" class="form-control" :disabled="disabled" />
</template>

<script>

import * as dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat)

import { IMaskComponent as ImaskInput, IMask } from 'vue-imask';

export default {
    name: 'RangeSliderInput',
    components: {
        ImaskInput
    },    
    props: {
        value: {
            type: String,
            default: null
        },
        mask: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            valueInput: ''
        }
    },
    computed: {
        imaskOptions: function () {
            return {
                overwrite: true,
                autofix: true,
                mask: 'HH:MM',
                blocks: {
                    HH: {
                        mask: IMask.MaskedRange,
                        placeholderChar: 'HH',
                        from: 0,
                        to: 23,
                        maxLength: 2
                    },
                    MM: {
                        mask: IMask.MaskedRange,
                        placeholderChar: 'MM',
                        from: 0,
                        to: 59,
                        maxLength: 2
                    }
                }
            }
        }
    },
    methods: {
        valueToValueInput: function (value) {
            return value ? value : '';
        },
        valueInputToValue: function (valueInput) {
            return valueInput.trim() === '' ? null: valueInput;
        },
        focusOut: function () {

            let time = this.valueInput;
            
            if ( this.valueInput.trim() == '' ) {
                time = dayjs().format('HH:mm')
            } else if ( this.valueInput.indexOf(':') == -1 ) {
                time += ':00';
            }
            
            this.valueInput = dayjs(time, 'HH:mm').format('HH:mm');
            this.$emit('valueSet', true);
        }
    },
    watch: {
        value: function (new_value, old_value) {
            if ( new_value !== old_value ) {
                this.valueInput = this.valueToValueInput(new_value);
            }
        },
        valueInput: function (new_value, old_value) {
            if ( new_value !== old_value ) {
                this.$emit('update:value', this.valueInputToValue(new_value));
            }
        }
    },
    mounted: function () {
        this.valueInput = this.valueToValueInput(this.value);
    }
}
</script>